import script from "./object_courseInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./object_courseInformation.vue?vue&type=script&setup=true&lang=js"

import "./object_courseInformation.vue?vue&type=style&index=0&id=659744bb&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659744bb"]])

export default __exports__